import React from 'react';
import { AppButton } from '../../components/AppButton/AppButton';

function NewLimitButton() {
    return (
        <AppButton
            id="btnNewLimit"
            variant="primary"
            size="md"
            data-bs-toggle="modal"
            data-bs-target="#modalLimit"
        >
            New limit
        </AppButton>
    );
}

export default NewLimitButton;